import { render, staticRenderFns } from "./TVGraph.vue?vue&type=template&id=53f52a25&scoped=true&"
import script from "./TVGraph.vue?vue&type=script&lang=js&"
export * from "./TVGraph.vue?vue&type=script&lang=js&"
import style0 from "./TVGraph.vue?vue&type=style&index=0&id=53f52a25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f52a25",
  null
  
)

export default component.exports